/** A tall purchase column scrolls into view before its bottom sticks. */
class FivepointBottomSticky extends HTMLElement {
  #observer;
  #column;
  connectedCallback() {
    this.#column = this.querySelector('[data-fp-bottom-sticky]');
    if (!this.#column) return;
    this.#observer = new ResizeObserver(this.#measure);
    this.#observer.observe(this.#column);
    const header = document.querySelector('[data-atelier-header]');
    if (header) this.#observer.observe(header);
    window.addEventListener('resize', this.#measure, { passive: true });
    this.#measure();
  }
  disconnectedCallback() {
    this.#observer?.disconnect();
    window.removeEventListener('resize', this.#measure);
  }
  #measure = () => {
    const header = document.querySelector('[data-atelier-header]');
    const top = Math.max(0, header?.getBoundingClientRect().bottom ?? 0) + 24;
    const bottom = window.innerHeight - this.#column.getBoundingClientRect().height - 24;
    this.#column.style.setProperty('--fp-purchase-sticky-top', `${Math.min(top, bottom)}px`);
  };
}
if (!customElements.get('fivepoint-bottom-sticky')) customElements.define('fivepoint-bottom-sticky', FivepointBottomSticky);
